import { Component, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { MyfileModel } from 'src/app/core/models/myfile/myfile.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';

@Component({
  selector: 'app-document-view-modal',
  templateUrl: './document-view-modal.component.html',
  styleUrls: ['./document-view-modal.component.scss']
})
export class DocumentViewModalComponent implements OnInit {
  constructor(
    private modalRef: NgbActiveModal,
    private sanitizer: DomSanitizer,
    ) { }
  @Input() public model: MyfileModel = new MyfileModel;  
  documentName: string = "DOCUMENT NAME";
  
  openViewString: string = "";

  ngOnInit(): void {
    if(this.model.document){
      var byteCharacters = atob(this.model.document.base64FileString);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      this.openViewString = fileURL;
      window.open(fileURL);
    }
  }

  close(){
    this.modalRef.close();
  }

}

